import './Frontend.css';
import VerticalStepper from '../UI/VerticalStepper';
import { useEffect, useState } from 'react';
import HomeNavbar from '../UI/HomeNavbar';
import { useUserAuth } from '../../context/UserAuthContext';
import LoadingModal from '../UI/LoadingModal';
import ErrorModal from '../UI/ErrorModal';

const Android = ({saveProgressData, getProgressData}) => {
    const SetupSteps = [
        {
            label: 'Install Android Studio',
            description: `Set up Android Studio, the official integrated development environment (IDE) for Android app development.`,
            link: 'https://youtu.be/gO-SWbJxKxc?si=B561GeYMFi0_1sDK'
        },
        {
            label: 'Configure Flutter Plugin',
            description: `Install and configure the Flutter plugin in Android Studio for seamless Flutter development.`,
            link: 'https://youtu.be/hfz_AraTk_k?si=4hpB9J_U0chOC7fL'
        }
    ];

    const BasicSteps = [
        {
            label: 'Dart Programming',
            description: `Get started with Dart programming language, the foundation of Flutter.`,
            link: 'https://youtu.be/Ej_Pcr4uC2Q?si=-CdDsd64OJE1-NMr'
        },
        {
            label: 'Flutter Installation',
            description: `Install Flutter and set up your development environment.`,
            link: 'https://youtu.be/BqHOtlh3Dd4?si=xaEm5MadA5wFSO10'
        },
        {
            label: 'Creating Your First Flutter App',
            description: `Step-by-step guide to creating a basic Flutter app.`,
            link: 'https://youtu.be/8sAyPDLorek?si=qpvyi0Ls3MmODhIu'
        }
    ];

    const WidgetSteps = [
        {
            label: 'Widget Catalog',
            description: `Explore Flutter's vast collection of pre-designed widgets for building UI.`,
            link: 'https://youtu.be/kj_tldMmu4w?si=pOsFER55nf5b2umn'
        },
        {
            label: 'Layout and Styling',
            description: `Learn about layouts, theming, and styling to create beautiful UI designs.`,
            link: 'https://youtu.be/u0e2L5yoxFI?si=zlNigrfGw04olwJp'
        },
        {
            label: 'Gesture Detection and Interaction',
            description: `Implement touch gestures and user interactions in your Flutter app.`,
            link: 'https://youtu.be/WhVXkCFPmK4?si=A4Na7xoyHBM0wzO-'
        }
    ];

    const StateMgmtSteps = [
        {
            label: 'Stateful vs Stateless',
            description: `Understand the concepts of stateful and stateless widgets.`,
            link: 'https://youtu.be/HsVUC6CcOqY?si=fPm2QUo0X8xfuFBv'
        },
        {
            label: 'Provider Package',
            description: `Explore state management using the Provider package for efficient UI updates.`,
            link: 'https://youtu.be/L_QMsE2v6dw?si=VZlFbSNgUGe-hyKM'
        },
        {
            label: 'Bloc Pattern',
            description: `Learn about the Bloc pattern for managing complex state in Flutter apps.`,
            link: 'https://youtu.be/rVI6IR1JiVA?si=kMtVYKN1uD160g_w'
        }
    ];

    const RoutingSteps = [
        {
            label: 'Navigation Basics',
            description: `Learn how to navigate between screens and handle routing.`,
            link: 'https://youtu.be/laqnY0NjU3M?si=21-Yioa4gBtyvsUG'
        },
        {
            label: 'Named Routes',
            description: `Implement named routes for structured navigation.`,
            link: 'https://www.geeksforgeeks.org/flutter-named-routes/'
        },
        {
            label: 'Navigation Drawer',
            description: `Create a navigation drawer for easy access to app sections.`,
            link: 'https://blog.logrocket.com/how-to-add-navigation-drawer-flutter/'
        }
    ];

    const APISteps = [
        {
            label: 'Fetching Data',
            description: `Learn how to make API requests and handle asynchronous data.`,
            link: 'https://youtu.be/rG7LY0BkvG8?si=b1fJAMzemxFhc--a'
        },
        {
            label: 'HTTP Package',
            description: `Explore Flutter's HTTP package for working with APIs.`,
            link: 'https://youtu.be/BrHoYWtCnTU?si=3P-Y40uJxO_x0_y_'
        },
        {
            label: 'Authentication with APIs',
            description: `Implement user authentication using API endpoints.`,
            link: 'https://youtu.be/qqTKtLgI9l8?si=iPuvUNFxXr2TiSdx'
        }
    ];

    const DeploymentSteps = [
        {
            label: 'Preparing for Release',
            description: `Optimize and configure your Flutter app for release.`,
            link: 'https://youtu.be/ZnufaryH43s?si=NUlCCaza4zKdR1vO'
        },
        {
            label: 'Play Store Publishing',
            description: `Learn the steps to publish your Flutter app on the Google Play Store.`,
            link: 'https://youtu.be/Uq1kYFcBRLI?si=nlW29vtIP7Gjbkw4'
        },
        {
            label: 'App Signing and Security',
            description: `Understand app signing and security considerations before publishing.`,
            link: 'https://youtu.be/wBYwZ6H3ucI?si=PlXZGGXT0TuQCczr'
        }
    ];

    // Totol Steps = 20

    // The total Progress is for progress graph for every user whereas individual step progress is for saving the progress in DB
    const [totalCompletedSteps, setTotalCompletedSteps] = useState(0);

    // Setup Progress
    const [setupCompletedSteps, setSetupCompletedSteps] = useState(0);

    const handleSetupStepComplete = () => {
        setSetupCompletedSteps(setupCompletedSteps + 1);
        setTotalCompletedSteps(totalCompletedSteps + 1);
        console.log(`Total Steps - ${totalCompletedSteps}`);
        console.log(setupCompletedSteps);
    };

    const handleSetupStepBack = () => {
        setSetupCompletedSteps(setupCompletedSteps - 1);
        setTotalCompletedSteps(totalCompletedSteps - 1);
        console.log(`Total Steps - ${totalCompletedSteps}`);
    };

    //Basics Progress
    const [basicCompletedSteps, setBasicCompletedSteps] = useState(0);

    const handleBasicStepComplete = () => {
        setBasicCompletedSteps(basicCompletedSteps + 1);
        setTotalCompletedSteps(totalCompletedSteps + 1);
        console.log(`Total Steps - ${totalCompletedSteps}`);
    };

    const handleBasicStepBack = () => {
        setBasicCompletedSteps(basicCompletedSteps - 1);
        setTotalCompletedSteps(totalCompletedSteps - 1);
        console.log(`Total Steps - ${totalCompletedSteps}`);
    };

    //Widgets Progress
    const [widgetCompletedSteps, setWidgetCompletedSteps] = useState(0);

    const handleWidgetStepComplete = () => {
        setWidgetCompletedSteps(widgetCompletedSteps + 1);
        setTotalCompletedSteps(totalCompletedSteps + 1);
        console.log(`Total Steps - ${totalCompletedSteps}`);
    };

    const handleWidgetStepBack = () => {
        setWidgetCompletedSteps(widgetCompletedSteps - 1);
        setTotalCompletedSteps(totalCompletedSteps - 1);
        console.log(`Total Steps - ${totalCompletedSteps}`);
    };

    //State Management Progress
    const [stateCompletedSteps, setStateCompletedSteps] = useState(0);

    const handleStateStepComplete = () => {
        setStateCompletedSteps(stateCompletedSteps + 1);
        setTotalCompletedSteps(totalCompletedSteps + 1);
        console.log(`Total Steps - ${totalCompletedSteps}`);
    };

    const handleStateStepBack = () => {
        setStateCompletedSteps(stateCompletedSteps - 1);
        setTotalCompletedSteps(totalCompletedSteps - 1);
        console.log(`Total Steps - ${totalCompletedSteps}`);
    };

    //Routing Progress
    const [routingCompletedSteps, setRoutingCompletedSteps] = useState(0);

    const handleRoutingStepComplete = () => {
        setRoutingCompletedSteps(routingCompletedSteps + 1);
        setTotalCompletedSteps(totalCompletedSteps + 1);
        console.log(`Total Steps - ${totalCompletedSteps}`);
    };

    const handleRoutingStepBack = () => {
        setRoutingCompletedSteps(routingCompletedSteps - 1);
        setTotalCompletedSteps(totalCompletedSteps - 1);
        console.log(`Total Steps - ${totalCompletedSteps}`);
    };

    //API Integration Progress
    const [apiCompletedSteps, setApiCompletedSteps] = useState(0);

    const handleApiStepComplete = () => {
        setApiCompletedSteps(apiCompletedSteps + 1);
        setTotalCompletedSteps(totalCompletedSteps + 1);
        console.log(`Total Steps - ${totalCompletedSteps}`);
    };

    const handleApiStepBack = () => {
        setApiCompletedSteps(apiCompletedSteps - 1);
        setTotalCompletedSteps(totalCompletedSteps - 1);
        console.log(`Total Steps - ${totalCompletedSteps}`);
    };

    //Deployment Progress
    const [deployCompletedSteps, setDeployCompletedSteps] = useState(0);

    const handleDeployStepComplete = () => {
        setDeployCompletedSteps(deployCompletedSteps + 1);
        setTotalCompletedSteps(totalCompletedSteps + 1);
        console.log(`Total Steps - ${totalCompletedSteps}`);
    };

    const handleDeployStepBack = () => {
        setDeployCompletedSteps(deployCompletedSteps - 1);
        setTotalCompletedSteps(totalCompletedSteps - 1);
        console.log(`Total Steps - ${totalCompletedSteps}`);
    };

    //Firestore data
    useEffect(() =>{
        saveProgressData({
            totalSteps: 20,
            totalCompletedSteps: totalCompletedSteps,
            setupCompletedSteps: setupCompletedSteps,
            basicCompletedSteps: basicCompletedSteps,
            widgetCompletedSteps: widgetCompletedSteps,
            apiCompletedSteps: apiCompletedSteps,
            stateCompletedSteps: stateCompletedSteps,
            routingCompletedSteps: routingCompletedSteps,
            deployCompletedSteps: deployCompletedSteps
        });
    }, [totalCompletedSteps, setupCompletedSteps, basicCompletedSteps, widgetCompletedSteps, apiCompletedSteps, stateCompletedSteps, routingCompletedSteps, deployCompletedSteps]);

    const {currentUser, isLoading} = useUserAuth();
    const [error, setError] = useState('');

    useEffect(() => {
        const asyncFunc = async() => {
            const progressData = await getProgressData();
            console.log(progressData);
            if (progressData) {
                setTotalCompletedSteps(progressData.totalCompletedSteps);
                setSetupCompletedSteps(progressData.setupCompletedSteps);
                setBasicCompletedSteps(progressData.basicCompletedSteps);
                setWidgetCompletedSteps(progressData.widgetCompletedSteps);
                setApiCompletedSteps(progressData.apiCompletedSteps);
                setStateCompletedSteps(progressData.stateCompletedSteps);
                setRoutingCompletedSteps(progressData.routingCompletedSteps);
                setDeployCompletedSteps(progressData.deployCompletedSteps);
            }
        };
        asyncFunc();
        if(!currentUser && !isLoading){
            setError('Error');
        }
        else{
            setError('');
        }
    }, [currentUser]);

    return (
        <body>
            <HomeNavbar/>
            <h1 className='tech-main-title'>Android Development Using Flutter</h1>
            <div className='web-container'>
                <div className='html-container'>
                    <h1 className='tech-title'>Setting Up Android Studio</h1>
                    <VerticalStepper steps={SetupSteps} onStepComplete={handleSetupStepComplete} onStepBack={handleSetupStepBack} stepsCompleted={setupCompletedSteps}/>
                </div>
                <div className='js-container'>
                    <h1 className='tech-title'>Flutter Basics</h1>
                    <VerticalStepper steps={BasicSteps} onStepComplete={handleBasicStepComplete} onStepBack={handleBasicStepBack} stepsCompleted={basicCompletedSteps}/>
                </div>
                <div className='react-container'>
                    <h1 className='tech-title'>Flutter Widgets</h1>
                    <VerticalStepper steps={WidgetSteps} onStepComplete={handleWidgetStepComplete} onStepBack={handleWidgetStepBack} stepsCompleted={widgetCompletedSteps}/>
                </div>
                <div className='api-container'>
                    <h1 className='tech-title'>State Management</h1>
                    <VerticalStepper steps={StateMgmtSteps} onStepComplete={handleStateStepComplete} onStepBack={handleStateStepBack} stepsCompleted={stateCompletedSteps}/>
                </div>
                <div className='git-container'>
                    <h1 className='tech-title'>Navigation and Routing</h1>
                    <VerticalStepper steps={RoutingSteps} onStepComplete={handleRoutingStepComplete} onStepBack={handleRoutingStepBack} stepsCompleted={routingCompletedSteps}/>
                </div>
                <div className='git-container'>
                    <h1 className='tech-title'>API Integration</h1>
                    <VerticalStepper steps={APISteps} onStepComplete={handleApiStepComplete} onStepBack={handleApiStepBack} stepsCompleted={apiCompletedSteps}/>
                </div>
                <div className='git-container'>
                    <h1 className='tech-title'>Deployment and Publishing</h1>
                    <VerticalStepper steps={DeploymentSteps} onStepComplete={handleDeployStepComplete} onStepBack={handleDeployStepBack} stepsCompleted={deployCompletedSteps}/>
                </div>
            </div>
            <ErrorModal errorMsg='Plz Login To Save Your Progress!' isError={error} />
            <LoadingModal isLoading={isLoading} msg={'Loading..'}/>
        </body>
    );
}

export default Android;